import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from "@angular/router";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient
} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from './app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { BaseComponent } from './components/base/base.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/office/about/about.component';
import { VisionComponent } from './pages/office/vision/vision.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CareerComponent } from './pages/career/career.component';
import { ConsultationComponent } from './pages/consultation/consultation.component';
import { TeamComponent } from './pages/team/team.component';
import { StaffComponent } from './pages/office/staff/staff.component';
import { ProjectManagementComponent } from './pages/service/project-management/project-management.component';
import { FacilityManagementComponent } from './pages/service/facility-management/facility-management.component';
import { ArbitrationComponent } from './pages/service/arbitration/arbitration.component';
import { PlanningComponent } from './pages/service/other-services/planning/planning.component';
import { DesigningComponent } from './pages/service/other-services/designing/designing.component';
import { SupervisionComponent } from './pages/service/other-services/supervision/supervision.component';
import { ConstructionManagementComponent } from './pages/service/other-services/construction-management/construction-management.component';
import { RoadsComponent } from './pages/service/other-services/roads/roads.component';
import { EnvironmentalSustainabilityComponent } from './pages/service/other-services/environmental-sustainability/environmental-sustainability.component';
import { VisionRealizationComponent } from './pages/service/other-services/vision-realization/vision-realization.component';
import { GreenBuildingsComponent } from './pages/service/other-services/green-buildings/green-buildings.component';
import { InfrastructureComponent } from './pages/service/other-services/infrastructure/infrastructure.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { BlogComponent } from './pages/blog/blog.component';
import { ArticleComponent } from './pages/blog/article/article.component';
import { TeamMemberComponent } from './pages/team/team-member/team-member.component';
import { TeamMember2Component } from './pages/team/team-member2/team-member2.component';
import { Page404Component } from './pages/page404/page404.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    NavbarComponent,
    BaseComponent,
    HomeComponent,
    AboutComponent,
    VisionComponent,
    ContactComponent,
    CareerComponent,
    ConsultationComponent,
    TeamComponent,
    StaffComponent,
    ProjectManagementComponent,
    FacilityManagementComponent,
    ArbitrationComponent,
    PlanningComponent,
    DesigningComponent,
    SupervisionComponent,
    ConstructionManagementComponent,
    RoadsComponent,
    EnvironmentalSustainabilityComponent,
    VisionRealizationComponent,
    GreenBuildingsComponent,
    InfrastructureComponent,
    ProjectsComponent,
    BlogComponent,
    ArticleComponent,
    TeamMemberComponent,
    TeamMember2Component,
    Page404Component
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    CarouselModule,
    RouterModule,
    NgxSpinnerModule,
    AppRoutingModule,
    BlockUIModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
